import styled from 'styled-components'

import { Text } from '@interco/inter-ui/components/Text'

export const HelpCenterButtonContainer = styled.button`
  width: 100%;
  height: 84px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid var(--gray200);
  background-color: var(--neutral-theme);
  cursor: pointer;
`

export const ButtonText = styled(Text)`
  text-align: start;
  width: 100%;
`
